// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#evaluations-panel .datepicker .icon {\n  color: var(--primary) !important;\n}\n@media only screen and (max-width: 768px) {\n#executive-filter-container span.select,\n  #executive-filter-container #executive-filter {\n    width: 100% !important;\n}\n}\n@media only screen and (min-width: 769px) and (max-width: 1160px) {\n.evaluations-content .columns{\n   display: block;\n}\n.evaluations-content .columns .column {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
